import PriceEngine from '../../assets/img/priceEngine.svg'
import MonopolioLabelBlack from '../../assets/img/monpolioLabel.svg'
import MonopolioLabelWhite from '../../assets/img/monopolioLabelWhite.svg'

interface MonopolioBrandProps {
  light?: boolean
}

const MonopolioBrand = ({ light }: MonopolioBrandProps): JSX.Element => {
  return (
    <div className="flex items-center gap-[6px] h-max w-max">
      <img
        src={(light ? MonopolioLabelBlack : MonopolioLabelWhite).src}
        alt="monopolio"
        width={73}
        height={14}
      />
      <img src={PriceEngine.src} alt="monopolio price engine" />
    </div>
  )
}

export default MonopolioBrand
